<ph-tooltip text="Super admin only"><ph-icon name="star" gap="before" label="Super admin only"></ph-icon></ph-tooltip>
